import { selectChangeMessageForConcordanties } from '@UI/aside/asideConcordanties/asideConcordantiesSelectors';
import { selectZillCurriculumNode } from '@newStore/documentUI/transformContent/zillContentNodeSelectors';
import { NodeType, type RootNodeConfig } from '@nodeTypeConfig/configTypes';
import { authorsComponent } from '@nodeTypeConfig/helpers/editComponents/authorsComponent';
import { descriptionComponent } from '@nodeTypeConfig/helpers/editComponents/descriptionComponent';
import {
  imageAlt,
  imageComponentBase,
} from '@nodeTypeConfig/helpers/editComponents/imageComponent';
import { publishComponent } from '@nodeTypeConfig/helpers/editComponents/publishComponent';
import { titleComponent } from '@nodeTypeConfig/helpers/editComponents/titleComponent';
import * as ACTION_TYPES from '@store/constants/actionTypes';
import { settings } from '../../settings';

const CURRICULUM_ZILL: RootNodeConfig = {
  nodeSelector: selectZillCurriculumNode,
  information: {
    definiteArticle: true,
    single: 'Leerplan ZILL',
    plural: 'Leerplannen ZILL',
    icon: require('../../../../img/icons/zill.svg'),
    category: 'LEERPLAN',
  },
  preloadActions: [
    {
      type: ACTION_TYPES.INIT_ZILL_ODET_CURRICULUM_DOCUMENT,
    },
  ],
  websiteHref: null,
  onLoadActions: [],
  relationsToIgnore: ['IS_VERSION_OF', 'IS_INCLUDED_IN', 'REPLACES', 'REFERENCES'],
  tocTypes: [
    NodeType.CURRICULUM_ZILL_CLUSTER,
    NodeType.CURRICULUM_ZILL_DEVELOPMENT_FIELD,
    NodeType.CURRICULUM_ZILL_DEVELOPMENT_THEME,
  ],
  buildingBlocks: [{ type: NodeType.CURRICULUM_ZILL_CLUSTER }],
  edit: [
    {
      ...titleComponent,
      width: 10,
    },
    {
      component: 'version',
      reactComponent: 'AsideVersion',
      label: 'Versie',
      property: '$$version',
      width: 2,
      readonly: true,
      noChangeMessage: true,
    },
    descriptionComponent,
    publishComponent,
    authorsComponent,
    {
      component: 'concordanties',
      reactComponent: 'AsideConcordanties', // TODO: this is the wrong component. this should be a reference frame picker.
      //  the changemessage crashes the component when changing reference frame.
      asideChangeMessageSelector: selectChangeMessageForConcordanties,
      label: 'Concordanties',
    },
    {
      ...imageComponentBase,
      label: 'Omslagfoto',
      options: {
        type: 'COVER_IMAGE',
        fields: [],
      },
    },
    {
      ...imageComponentBase,
      label: 'Miniatuur',
      options: {
        type: 'THUMBNAIL',
        fields: imageAlt,
      },
    },
    {
      ...imageComponentBase,
      label: 'Achtergrond',
      options: {
        type: 'BACKGROUND_IMAGE',
        fields: [],
      },
    },
  ],
  disableDeleteWhenIssued: true,
  allowSuggestions: false,
  isCreatable: true,
  isSearchable: true,
  previewModes: [
    {
      type: 'URL',
      name: 'Zill Leerplansite',
      location: `${settings.apisAndUrls.zill}/#!/leerinhoud?preview&version=/content/{%key}`,
    },
    {
      type: 'URL',
      name: 'Zill Selectietool',
      location: `${settings.apisAndUrls.zillSelector}/#/?preview&version=/content/{%key}`,
    },
  ],
};

export default CURRICULUM_ZILL;
